import $defaultVertex from "./default.vert.mjs";
import $defaultFilterVertex from "./defaultFilter.vert.mjs";
const defaultVertex = $defaultVertex, defaultFilterVertex = $defaultFilterVertex;
export {
  defaultFilterVertex,
  defaultVertex
};
//# sourceMappingURL=index.mjs.map
